import React from "react";

export const Learning2 = () => {
  return (
    <svg width={14} height={17} viewBox="0 0 14 17" fill="none">
      <path
        d="M1.667 13.396a1.77 1.77 0 011.77-1.771H13"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.438 1H13v14.167H3.438a1.77 1.77 0 01-1.771-1.771V2.77A1.77 1.77 0 013.437 1v0z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
